import React, { createContext, useContext, useState } from "react";

export interface AppNotification {
  id: string;
  message: string;
  read: boolean;
  status: string;
  clickable?: boolean;
  session:number;
  docName:string;

}

export interface NotificationContextType {
  notifications: AppNotification[];
  addNotification: (notif: AppNotification) => void;
  markAsRead: (id: string) => void;
  removeNotification: (id: string) => void;
   clearNotifications: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notifications, setNotifications] = useState<AppNotification[]>([]);

  const addNotification = (notif: AppNotification) => {
    setNotifications((prev) => [...prev, notif]);
  };

  const clearNotifications = () => {
    setNotifications([]);
  };

  const removeNotification = (id: string) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const markAsRead = (id: string) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true } : n))
    );
  };

  return (
    <NotificationContext.Provider value={{ notifications, addNotification, markAsRead, clearNotifications, removeNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error("useNotification must be used inside NotificationProvider");
  return ctx;
};
